<script setup lang="ts">
import { provide } from 'vue';
import { navBarSideKey, registerNavBarItemKey } from './internal';
import type { NavBarSide, RegisterFn } from './types';

const props = defineProps<{
  side: NavBarSide;
  register: RegisterFn;
}>();

provide(navBarSideKey, props.side);
provide(registerNavBarItemKey, props.register);
</script>

<template>
  <slot />
</template>
